import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { LANGUAGE_CONSTANTS as LANG_CONST } from 'src/app/shared/constants/language-constants';
import { Utility, convertNumber } from 'src/app/shared/utils/utility.service';
import { CONSTANTS } from 'src/app/shared/constants/constants';
import { IDefaultUserGroup } from '../activity/user-card.interface';
import { HelperService } from 'src/app/shared/utils/helper.service';
import { MultiUserShareAccessComponent } from 'src/app/user-management/multi-user-share-access/multi-user-share-access.component';
import { DashboardManagementService } from 'src/app/dashboard/dashboard-management.service';
import { SharedDataService } from 'src/app/shared/services/shared-data.service';
import { Subscription } from 'rxjs';
import { CommonService } from 'src/app/shared/utils/common.service';
import { StateManagementService } from 'src/app/shared/services/state-management.service';

@Component({
  selector: 'app-dashboard-user-card',
  templateUrl: './dashboard-user-card.component.html',
  styleUrls: ['./dashboard-user-card.component.scss'],
})
export class DashboardUserCardComponent implements OnInit, OnDestroy {
  readonly LANG_CONST = LANG_CONST;
  readonly CONSTANTS = CONSTANTS;
  @Input() user!: IDefaultUserGroup;
  sharedData!: any;
  siteId!: string;
  profileImageSrc: string = 'assets/images/portrait-happy.jpg';
  userManagementSubscription: Subscription | undefined;
  searchKeyPress: boolean = false;
  isDashboard: boolean = true;
  commonAccessControl!: boolean;
  convertNumber = convertNumber;
  constructor(
    private helperService: HelperService,
    public dashboardManagementService: DashboardManagementService,
    private sharedDataService: SharedDataService,
    public commonService: CommonService,
    private stateManagementService: StateManagementService
  ) {}

  // eslint-disable-next-line @angular-eslint/no-empty-lifecycle-method
  ngOnInit(): void {
    this.commonAccessControl = this.stateManagementService.getSharedData()?.selectedSite?.commonAccessControl; 
    this.sharedDataService.currentData.subscribe((sharedData: any) => {
      this.sharedData = sharedData;
      this.siteId = this.sharedData.selectedSite.siteId;
    });

    this.userManagementSubscription =
      this.dashboardManagementService?.triggerRerender?.subscribe(
        (result: boolean) => {
          if (result) {
            this.searchKeyPress = true;
            this.dashboardManagementService
              .getDashboardStatistics(this.siteId)
              .subscribe();
            this.dashboardManagementService.setTriggerRerender(false);
          }
        }
      );
  }

  /**
   *
   * @param data string content
   * @returns enccode string into base64
   */
  encode(data: string): string {
    return Utility.encodeToBase64(data);
  }

  addUserHandler(userGroup: any) {
    const dialogInstance = this.helperService.openModalDialog(
      MultiUserShareAccessComponent,
      {
        group: userGroup,
        users: [],
        isDashboard: this.isDashboard,
      },
      CONSTANTS.FIXED_SCREEN_MODAL
    );

    dialogInstance?.afterClosed().subscribe((users: any) => {
      this.dashboardManagementService
        .getDashboardStatistics(this.siteId)
        .subscribe();
    });
  }
  ngOnDestroy(): void {
    this.userManagementSubscription?.unsubscribe();
  }
}
